import { AGILE_HELP_PAGE_URL } from "@teams/cards";
import React from "react";

import { TabConfigPage } from "../../_shared/pages/TabConfigPage";

export const AgileTabConfigPage: React.FC = () => {
  return (
    <TabConfigPage
      applicationType="agile"
      urlBase="/agile"
      entityPrefix="agile_list"
      displayName="AgilePolly"
      title="Add AgilePolly to a tab to manage all your channel standups in one place"
      helpLink={AGILE_HELP_PAGE_URL}
    />
  );
};
